import { z } from 'zod';

export const userIdParam = z.object({ id: z.string().min(1) });
export type UserIdParam = z.infer<typeof userIdParam>;

export const createUserBody = z.object({
  name: z.string().min(1),
  email: z.email(),
  password: z.string().min(1),
});
export type CreateUserBody = z.infer<typeof createUserBody>;

export const updateUserBody = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  email: z.email(),
});
export type UpdateUserBody = z.infer<typeof updateUserBody>;
